export default "__VITE_ASSET__BLzrqYZX__"